import AppRoute from "models/AppRoute"

const AssetCreateRoute = new AppRoute({
    route: "/asset/create",
    navbar: true,
    authRequired: true,
})

export default AssetCreateRoute
